import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReuniaoCanDeactivate } from '../../reuniao-can-deactivate';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AdminService } from '../../services/admin.service';
import { Admin } from '../../models/admin.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminResolverId } from '../../resolver/admin.resolver';

@Component({
  selector: 'app-admin-edit',
  templateUrl: './admin-edit.component.html',
  styleUrls: ['./admin-edit.component.scss']
})
export class AdminEditComponent extends BaseFormComponent<Admin> implements OnInit, ReuniaoCanDeactivate {

  actionLabel: string = 'Novo';
  data: Admin;
  @Input() id: number;
  @Input() type: string;
  @Output() closeModal = new EventEmitter<void>();
  @Output() excluir = new EventEmitter<void>();
  constructor(
      public activatedRoute: ActivatedRoute,
      public myService: AdminService,
      public adminResolverId: AdminResolverId
    ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.initForm();
    this.start();
  }
  initForm() {
    this.form = new FormGroup({
      id: new FormControl(this.id),
      type: new FormControl(this.type),
      name: new FormControl('', [Validators.required])
    });
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }
  
  start(){
    if(this.id){
      this.adminResolverId.getByIdAndType(this.id, this.type ).subscribe({
        next: (data) => {
          this.entity = data;
          this.data = data;
          this.initForm();
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
    }
    else{
      this.loaded();
    }
  }

  canDeactivate(): boolean {
    return !this.form.dirty;
  }


  getDataCreate() {
    return Object.assign({}, this.form.value);
  }

  salvar(msg = "Deseja salvar as alterações?"): void {
    if (this.form.valid) {
      this.alertConfirmation(null,msg).subscribe((confirmed) => {
        if (confirmed) {
          this.loading();
          var newData = this.getDataCreate();
          if(newData['id']){
            this.myService.update(newData,newData['id']).subscribe({
              next: (res) => {
                this.form.markAsPristine();
                this.confirmation("Alteradado com sucesso!").subscribe(() => {
                  window.location.reload();                
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error.error.message);
                this.loaded();
              },
            });
          }
          else{
            this.myService.create(newData).subscribe({
              next: (res) => {
                this.form.markAsPristine();
                this.confirmation("Criado com sucesso!").subscribe(() => {
                  window.location.reload();                
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error.error.message);
                this.loaded();
              },
            });
          }
          
        }
      });
    }
    else {
      this.markAsDirty();
    }
  }

  
  onCloseModal(){
    this.closeModal.emit();
  }
  onExcluir(){
    this.excluir.emit();
  }

  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }
  //detecta se o formulário está manipulado e se  pessoa está atualizando a página ou saindo dela.
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: BeforeUnloadEvent): void {
    if (this.form.dirty) {
      event.preventDefault();
    }
  }

}
